// extracted by mini-css-extract-plugin
export default {"home_header":"HomePage_home_header__eniT3","cover_image":"HomePage_cover_image__rQLG+"};